import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import { store } from "@/commonui/store/index";
import { IVersionGroupService, VersionGroupModel, VersionGroupRequestModel, VersionGroupService } from "@/services";
import { fmtMsg, isGuid, MessageHelper, NotificationType } from "commonui";
import { VcsLocale } from "@/locales/localeid";
import { ResponseHelper } from "@/util/helper";
import { CurriculumType } from "@/util/enum";

@Module({ namespaced: true, name: "VersionGroupState", store: store, dynamic: true })
class VersionGroupState extends VuexModule {
	versionGroups: VersionGroupModel[] = [];
	loading: boolean = true;
	selectedGsVersion: string = "-1";
	selectedLsVersion: string = "-1";
	disabled: boolean = true;
	versionService: IVersionGroupService = VersionGroupService();

	@Mutation
	async setDisabled(value: boolean) {
		this.disabled = value;
	}

	@Mutation
	async setLoading({ loading }) {
		this.loading = loading;
	}

	@Mutation
	async setGsVersion(version: string) {
		if (isGuid(version) && this.versionGroups.some((s) => s.id === version)) {
			this.selectedGsVersion = version;
		} else {
			this.selectedGsVersion = "-1";
		}
	}

	@Mutation
	async setLsVersion(version: string) {
		if (isGuid(version) && this.versionGroups.some((s) => s.id === version)) {
			this.selectedLsVersion = version;
		} else {
			this.selectedLsVersion = "-1";
		}
	}

	@Mutation
	setVersionGroups(value: VersionGroupModel[]) {
		this.versionGroups = value;
	}

	@Action
	async refreshVersionGroup(resetLoading = true) {
		const groups = (await VersionGroupService()
			.getVersions(false)
			.catch((reason) => {
				if (ResponseHelper.isForbiddenResponse(reason)) {
					return [] as VersionGroupModel[];
				}
			})) as VersionGroupModel[];
		this.setVersionGroups(groups);
		this.setLoading({ loading: resetLoading ? false : true });
	}

	@Action
	async createVersion(versions: VersionGroupRequestModel[]) {
		const localeId =
			versions[0].curriculumType === CurriculumType.GrapeSEED
				? VcsLocale.VersionGroupGrapeCreateSuccess
				: VcsLocale.VersionGroupLittleCreateSuccess;
		const message = fmtMsg(localeId, { name: versions[0].name.trim() });
		this.versionService
			.createVersions(versions)
			.then((newVersionGroupId) => {
				MessageHelper.Message(NotificationType.Success, message);
				this.refreshVersionGroup();
			})
			.catch(() => {
				MessageHelper.Message(NotificationType.Failed, fmtMsg(VcsLocale.VersionGroupCreateFail));
			});
	}
}

export const VersionGroupModule = getModule(VersionGroupState);
